"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.SubForm = exports.SUB_FORM_BORDER_WIDTH = void 0;
const pdfTheme_1 = require("../pdfTheme");
exports.SUB_FORM_BORDER_WIDTH = 2;
class SubForm {
    constructor(subFormTitle, subFormSubTitle, content) {
        this.subFormTitle = subFormTitle;
        this.subFormSubTitle = subFormSubTitle;
        this.nodes = [];
        this.nodes = [...content];
    }
    exportContent() {
        return {
            layout: {
                hLineWidth: () => 0,
                vLineWidth: () => 0,
                hLineColor: () => pdfTheme_1.pdfTheme.background.light,
                vLineColor: () => pdfTheme_1.pdfTheme.background.light,
                paddingLeft: () => pdfTheme_1.pdfTheme.spacing.large,
                paddingRight: () => 0,
                paddingTop: () => pdfTheme_1.pdfTheme.spacing.default,
                paddingBottom: (i) => i === 0 ? pdfTheme_1.pdfTheme.spacing.default : 0
            },
            style: ['subForm'],
            table: {
                widths: ['*'],
                body: [
                    [
                        {
                            fillColor: pdfTheme_1.pdfTheme.background.light,
                            columnGap: 3,
                            columns: [
                                {
                                    text: `${this.subFormTitle}:`,
                                    width: 'auto',
                                    style: ['subFormTitle']
                                },
                                {
                                    text: this.subFormSubTitle,
                                    style: ['subFormSubTitle']
                                }
                            ]
                        }
                    ],
                    [
                        {
                            stack: this.nodes.map(node => node.exportContent()),
                            marginLeft: pdfTheme_1.pdfTheme.spacing.default
                        }
                    ]
                ]
            }
        };
    }
    exportStyles() {
        return {
            subForm: {
                marginBottom: pdfTheme_1.pdfTheme.spacing.small
            },
            subFormTitle: {
                fontSize: pdfTheme_1.pdfTheme.font.size.default,
                bold: true
            },
            subFormSubTitle: {
                fontSize: pdfTheme_1.pdfTheme.font.size.default
            }
        };
    }
}
exports.SubForm = SubForm;
//# sourceMappingURL=SubForm.js.map